var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.waitForNewVersione == false)?_c('router-view'):_vm._e()],1),_c('toast'),_c('confirm'),_c('wait'),_c('passwordInput')],1)}
var staticRenderFns = []

export { render, staticRenderFns }